export const LS_KEY_STORE = 'Store';
